<template>
<img src="../../assets/marca.png" alt="Federação Baiana, Capixaba e Mineira de Golfe" :style="{height}"/>
</template>

<script>
export default {
  name: "AppLogo",
  props: ['height']
}
</script>

<style scoped>

</style>